module.exports = __webpack_public_path__ + "img/battery_0classic.920afae8.png";